import { useEffect } from "react";

import { t } from "i18n/i18n";
import { Dialog } from "mds/components/Dialog";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { useAppSelector } from "store/index";
import { selectShowForceReloadModal } from "store/selectors/view";
import { BUTTON_EVENT_CATEGORY, trackEvent } from "utils/amplitude";
import { clearCacheAndReload } from "utils/urls";

const handleReload = () => {
  trackEvent("Force reload modal - Reload clicked", BUTTON_EVENT_CATEGORY);
  clearCacheAndReload();
};

export const ForceReloadModal = () => {
  const showForceReloadModal = useAppSelector(selectShowForceReloadModal);

  useEffect(() => {
    if (showForceReloadModal) {
      trackEvent("Force reload modal displayed", BUTTON_EVENT_CATEGORY);
    }
  }, [showForceReloadModal]);

  return (
    <Dialog
      className="confirm-modal z-[10001]"
      description={t("warning.force_reload.message")}
      dismissible={false}
      open={showForceReloadModal}
      title={t("warning.force_reload.title")}
      onClose={() => {}}
    >
      <div className="flex w-full justify-end pt-4">
        <SquareButton kind="accent" size="m" autoFocus onClick={handleReload}>
          {t("warning.force_reload.reload_button")}
        </SquareButton>
      </div>
    </Dialog>
  );
};
